module.exports = __webpack_public_path__ + "static/images/hb3.db15619.jpg";